import styled from 'styled-components';
import { colors } from '../../assets/variables';

const Wrap = styled.div`
  display: flex;
  margin: 16px 0px 32px;
  min-height: 600px;
  width: 100%;
  min-width: 100%;
  flex-direction: column;
  .new-location {
    :hover,
    :focus {
      svg {
        path {
          fill: ${colors.primary};
        }
      }
    }
  }
`;

export default { Wrap };
